function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M31.4,4.3L6.4,25.8v65.4h106.8V4.3H31.4z M73.5,82.3L69.7,66H52.4l-3.6,16.3h-9.3l16.9-71.6h9.3L83,82.3H73.5z "
}), React.createElement("polygon", {
  className: "st0",
  points: "55.1,54 66.9,54 60.9,27.4  "
}));

var SvgSdCardAIcon = function SvgSdCardAIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 118.4 96.1",
    style: {
      enableBackground: "new 0 0 118.4 96.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSdCardAIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sd-card-a-icon.112bc963.svg";
export { ForwardRef as ReactComponent };